import { Box, Typography } from "@mui/joy";
import { ChevronRight } from "lucide-react";

import { Button } from "../../shared";

type NoOrganizationAccessProps = {
	onBackToLogin: () => void;
};

export default function NoOrganizationAccess({ onBackToLogin }: NoOrganizationAccessProps) {
	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			minHeight="100vh"
			gap={1}
			px={2}
			textAlign="center"
		>
			<Typography level="title-lg">No organization access</Typography>
			<Typography level="body-md" color="neutral" sx={{ maxWidth: 420 }}>
				You are not part of any organization. Please connect with your administrator to get access.
			</Typography>
			<Button sx={{ mt: 2 }} endDecorator={<ChevronRight size={16} />} onClick={onBackToLogin}>
				Back to login
			</Button>
		</Box>
	);
}
